import TrafficConfigList from '../components/TrafficConfigList.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: TrafficConfigList,
    meta: {
      title: 'Traffic Configuration',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'traffic-config/list',
          title: 'Traffic Configuration'
        }
      ]
    }
  }
];
